import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Title from 'antd/es/typography/Title';
import { useTransition, animated, config } from '@react-spring/web';
import {
  Button,
  Modal,
  Typography,
  Form,
  Input,
  UploadProps,
  notification,
  Upload,
  Image,
} from 'antd';
import { Carousel } from 'antd';
import { EditTwoTone, RightOutlined } from '@ant-design/icons';
import './index.css';
import {
  downloadAvatar,
  useGetCurrentUserCompanyQuery,
  userInfoApi,
  useUpdateUserInfoMutation,
  useUploadAvatarMutation,
} from '@/services/api/user-info.api';
import { useAddNewsMutation, useGetAllNewsQuery } from '@/services/api/news.api';
import { isError } from 'lodash';
import { News } from '@/shared/model/news.model';

const { Text, Paragraph } = Typography;

interface Slide {
  id: number;
  content: string;
}

interface SliderProps {
  slides: Slide[];
}

interface SliderArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const SampleNextArrow: React.FC<SliderArrowProps> = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        // marginTop:'-30px',
        // padding:'20px 20px 0 20px',
        // display: 'block',
        fontSize: '25px',
        // backgroundColor: 'rgb(165, 204, 231)',
        // borderRadius: '40px',
        color: 'black',
      }}
      onClick={onClick}
    >
      {/* <RightOutlined /> */}
    </div>
  );
};

const SamplePrevArrow: React.FC<SliderArrowProps> = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        // marginTop:'-30px',
        // padding:'20px 20px 0 20px',
        // display: 'block',
        fontSize: '25px',
        // backgroundColor: 'rgb(165, 204, 231)',
        // borderRadius: '40px',
        color: 'black',
      }}
      onClick={onClick}
    ></div>
  );
};

const SimpleSlider = ({ display }: any) => {
  const [
    uploadImageFile,
    {
      data: upLoadImage,
      isError: uploadImageError,
      isLoading: uploadImageLoading,
      isSuccess: uploadImageSuccess,
    },
  ] = useUploadAvatarMutation();
  const [
    downloadImage,
    {
      data: image,
      isLoading: isLoadingGetImage,
      isSuccess: isSuccessGetImage,
      isError: isErrorGetImage,
    },
  ] = userInfoApi.endpoints.downloadAvatar.useLazyQuery();
  const [
    addNews,
    { data: updatedNews, isLoading: isLoadingAdd, isSuccess: isSuccessAdd, isError: isErrorAdd },
  ] = useAddNewsMutation();
  // const { data: dataNews = [], isLoading: isLoadingGet, isSuccess: isSuccessGet, isError: isErrorGet, refetch: refetchNewsList } = useGetAllNewsQuery()
  const {
    data: useInfo,
    isLoading: isLoadGetUserInfo,
    isError: isErrorGetUserInfo,
    isSuccess: isSuccessGetUserInfo,
    refetch,
  } = useGetCurrentUserCompanyQuery(); // useGetUserInfoQuery()

  const [imageState, setImageState] = useState<string>('');

  const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg'];
  const [form] = Form.useForm();

  const [editNews, setEditNews] = useState(false);

  const handleOk = () => {
    // setEditNews(false);
    form
      .validateFields()
      .then(values => {
        values = {
          ...values,
          image: upLoadImage?.fileRef,
        };
        console.log(values);
        addNews(values);
      })
      .catch(errorInfo => {
        console.log(errorInfo);
      });
  };

  const handleCancel = () => {
    // setEditNews(false)
    // setImageState("")
    // refetchNewsList()
  };

  const uploadAvatar: UploadProps = {
    // // onRemove: file => { },
    beforeUpload: file => {
      const isImage = validImageTypes.includes(file.type);
      const maxSizeMB = 5;

      if (!isImage) {
        notification.error({ message: `${file.name} is not a valid image` });
        return Upload.LIST_IGNORE;
      }

      if (file.size / 1024 / 1024 > maxSizeMB) {
        notification.error({
          message: `${file.name} exceeds the maximum file size of ${maxSizeMB}MB`,
        });
        return Upload.LIST_IGNORE;
      }
      const formData = new FormData();
      formData.append('file', file);
      uploadImageFile(formData);
      return false;
    },
  };

  const slides = [
    {
      id: 91,
      link: 'https://vnba.org.vn/vi/hiep-hoi-ngan-hang-viet-nam-chinh-thuc-khoi-dong-thi-diem-nen-tang-co-so-du-lieu-tai-tro-thuong-mai-21234.htm',
      content: 'FPT đồng hành cùng Hiệp hội Ngân hàng Việt Nam khởi động thí điểm nền tảng dữ liệu tài trợ thương mại',
      image: '/images/home/Overview/vnba_tfr.jpg',
    },
    {
      id: 92,
      link: 'https://bidv.com.vn/?urile=wcm:path:/wps/wcm/connect/BIDV/doanh-nghiep/khach-hang-doanh-nghiep/khuyen-mai/tai-tro-thuong-mai/BIDV-Tradeflat-dong-hanh-cung-doanh-nghiep-kien-tao-xu-huong-xuat-nhap-khau-tuong-lai',
      content:
        'BIDV TradeFlat đồng hành cùng doanh nghiệp kiến tạo xu hướng xuất nhập khẩu tương lai',
      image: '/images/home/Overview/bidv_tradeflat_thuc_day_giao_thuong.png',
    },
    {
      id: 93,
      link: 'https://vnexpress.net/techcombank-hop-tac-fpt-cung-cap-giai-phap-so-cho-hang-nghin-dai-ly-4908230.html',
      content: 'Techcombank hợp tác FPT cung cấp giải pháp số cho hàng ngàn Đại lý',
      image: '/images/home/Overview/techcombank_tradeflat_giai_phap_so.png',
    },
    {
      id: 94,
      link: 'https://vnexpress.net/fpt-is-hop-tac-bidv-xay-dung-he-sinh-thai-so-xuat-nhap-khau-4804837.html',
      content: 'FPT IS hợp tác BIDV xây dựng hệ sinh thái số xuất nhập khẩu',
      image: '/images/home/Overview/FPTBIDV-1259-1729062101.jpg',
    },
    {
      id: 95,
      link: 'https://cafef.vn/nen-tang-make-in-vietnam-thuc-day-giao-thuong-vietnam-new-zealand-188240427132221965.chn',
      content: 'Nền tảng Make in Vietnam thúc đẩy giao thương Vietnam - New Zealand',
      image: '/images/home/Overview/avatar1714198792172-17141987925581896113688.png',
    },
    {
      id: 96,
      link: 'https://cafebiz.vn/hop-tac-viet-nhat-tao-diem-sang-cho-thuong-mai-chau-a-thai-binh-duong-176231218145645501.chn',
      content: 'Hợp tác Việt - Nhật tạo điểm sáng cho thương mại châu Á - Thái Bình Dương',
      image:
        'https://w.ladicdn.com/s600x500/60b444ceeba2a30012e68735/photo-1-17028732869522091994057-1-20231221063307-vsb_i.png',
    },
    {
      id: 97,
      link: 'https://vnexpress.net/fpt-hop-tac-ong-lon-thuong-mai-so-nhat-ban-4668443.html',
      content: 'FPT hợp tác ông lớn thương mại số Nhật Bản',
      image:
        'https://w.ladicdn.com/s600x500/60b444ceeba2a30012e68735/so-1-nhat-ban-20231211154755-6efzs.jpg',
    },
    {
      id: 98,
      link: 'https://vtv.vn/cong-nghe/trinh-dien-cong-nghe-ai-blockchain-tu-dong-hoa-rpa-tai-industry-40-20230615095607887.htm',
      content: 'Trình diễn công nghệ AI, Blockchain, Tự động hoá RPA tại Industry 4.0',
      image:
        'https://w.ladicdn.com/s600x500/60b444ceeba2a30012e68735/gian-han-cong-nghe-20231211154755-p4uly.jpg',
    },
    {
      id: 99,
      link: 'https://www.techsignin.com/fpt-vietnam-blockchain-summit-2022/',
      content: 'FPT trình diễn hệ sinh thái sản phẩm ứng dụng công nghệ blockchain',
      image:
        'https://w.ladicdn.com/s600x500/60b444ceeba2a30012e68735/blockchain-20231211154755-hxtvd.jpg',
    },
    {
      id: 100,
      link: 'https://baotintuc.vn/khoa-hoc-cong-nghe/gioi-cong-nghe-viet-nam-va-quoc-te-hoi-tu-tai-fpt-techday-2023-20231024144121675.htm',
      content: 'Giới công nghệ Việt Nam và quốc tế hội tụ tại FPT Techday 2023',
      image:
        'https://w.ladicdn.com/s600x500/60b444ceeba2a30012e68735/techday241023-2-20231211155137-nejf0.jpg',
    },
  ];

  const [listNews, setListNews] = useState<News[]>();

  const [ellipsis, setEllipsis] = useState(true);
  const titleTransition = useTransition(display, {
    from: { y: -100, opacity: 0 },
    enter: { y: 0, opacity: 1 },
    config: config.slow,
    delay: 500,
  });

  const sectionTransition = useTransition(display, {
    from: { x: -100, opacity: 0 },
    enter: { x: 0, opacity: 1 },
    config: config.slow,
    delay: 500,
  });

  const contentStyle: React.CSSProperties = {
    borderRadius: 10,
    height: '30vh',
    margin: 0,
    marginBottom: 20,
    // padding: '20px',
    padding: '30px 0',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: 'white',
    marginLeft: 10,
    marginRight: 10,
  };

  // useEffect(() => {
  //   if (dataNews) {
  //     const downloadAllImages = async () => {
  //       const updatedNews = await Promise.all(dataNews.map(async (news) => {
  //         const response = await downloadImage(news.image || "");
  //         return { ...news, image: response.data || news.image };
  //       }));
  //       setListNews(updatedNews || []);
  //     };

  //     console.log(listNews)

  //     downloadAllImages();
  //   }
  // }, [isSuccessGet])

  useEffect(() => {
    setImageState(image || '');
  }, [image]);

  // useEffect(() => {
  //   if (uploadImageSuccess && upLoadImage?.fileRef) {
  //     downloadImage(upLoadImage?.fileRef)
  //   }
  //   else {
  //     console.log(upLoadImage?.fileRef)
  //   }
  // }, [uploadImageSuccess, uploadImageLoading, uploadImageFile])

  // useEffect(() => {
  //   if (isSuccessAdd) notification.success({ message: "Thêm tin tức thành công!" })
  //   else if (isErrorAdd) notification.error({ message: "Thêm tin tức thất bại!" })
  // }, [addNews, isSuccessAdd, isLoadingAdd, isErrorAdd])

  // useEffect(()=> {
  //   console.log("useInfo: ", useInfo)
  // }, [])

  return (
    <div
      style={{
        backgroundColor: 'rgb(239, 248, 255)',
        padding: '20px 0 60px 0',
        marginTop: '3%',
        textAlign: 'center',
      }}
    >
      {titleTransition((style, item) => (
        <animated.div style={style}>
          <Title level={3} style={{ textAlign: 'center', marginBottom: 35 }}>
            Tin tức - Sự kiện
            {useInfo && useInfo.email === 'phamanhvu1424@gmail.com' && (
              <Button type="text" onClick={() => setEditNews(true)}>
                <EditTwoTone />
              </Button>
            )}
          </Title>
        </animated.div>
      ))}

      <Carousel
        // autoplay={true}
        // autoplaySpeed={1000}
        swipeToSlide={true}
        infinite={true}
        speed={1000}
        slidesToShow={4}
        slidesToScroll={1}
        // arrows
        // nextArrow={<SampleNextArrow />}
        // prevArrow={<SamplePrevArrow />}
        initialSlide={0}
        responsive={[
          {
            breakpoint: 1760,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            },
          },
          {
            breakpoint: 875,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            },
          },
        ]}
        style={{ width: '70%', margin: 'auto' }}
      >
        {slides.map(item => (
          <div>
            <div style={contentStyle}>
              <Link
                to={item.link || ''}
                style={{ textDecoration: 'none' }}
                className="link-container"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={item.image || ''}
                  style={{ display: 'block', margin: 'auto', width: '250px', height: '170px' }}
                  alt=""
                  // fallback="data:image/png;base64,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"
                  // preview={false}
                />
                <Paragraph style={{ margin: '20px 30px 0 30px' }} ellipsis={{ rows: 3 }}>
                  {item.content}
                </Paragraph>
              </Link>
            </div>
          </div>
        ))}
        {/* <div>
          <h3 style={contentStyle}>1</h3>
        </div>
        <div>
          <h3 style={contentStyle}>2</h3>
        </div>
        <div>
          <h3 style={contentStyle}>3</h3>
        </div>
        <div>
          <h3 style={contentStyle}>4</h3>
        </div> */}
      </Carousel>
      <Modal open={editNews} onOk={handleOk} onCancel={handleCancel}>
        <Form colon={false} form={form}>
          <Image
            src={imageState || ''}
            preview={false}
            style={{ width: '100%', maxHeight: '20vw' }}
            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
          />
          <Form.Item
            // label="Ảnh"
            name="image"
            rules={[{ required: true, message: 'Hãy tải ảnh lên!' }]}
          >
            <Upload
              name={'image'}
              {...uploadAvatar}
              className="avatar-uploader"
              showUploadList={false}
              action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            >
              <Button style={{ width: '100%', padding: '0 8vw' }}>Tải ảnh lên</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            label="Mô tả"
            name="content"
            rules={[{ required: true, message: 'Hãy nhập mô tả của tin tức' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="URL"
            name="link"
            rules={[{ required: true, message: 'Hãy nhập URL của tin tức' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default SimpleSlider;
